<template>
  <div class="d-flex align-center">
    <v-menu v-model="showMenu" min-width="120px" max-width="200px" offset-y>
      <template v-slot:activator="{on, attrs}">
        <div
          v-if="$vuetify.breakpoint.mdAndUp"
          v-bind="attrs"
          v-on="on"
          class="info--text cursor-pointer"
          :class="{'mr-4 btn-text': $vuetify.breakpoint.mdAndUp}"
          @click="onViewProfile"
        >
          Xin chào phụ huynh {{ user.name }}
        </div>
      </template>
    </v-menu>
    <v-icon class="cursor-pointer" @click="onViewProfile" v-if="$vuetify.breakpoint.smAndDown" color="primary"
      >mdi-qrcode</v-icon
    >
    <v-btn color="primary" class="text-none ml-3" outlined rounded @click="$router.push('/surveys')">
      <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-clipboard-text-outline</v-icon>
      <span v-if="$vuetify.breakpoint.mdAndUp">Khảo sát</span>
    </v-btn>
    <v-btn
      color="error"
      class="text-none ml-6"
      v-if="isOpen"
      :class="{'mr-4 btn-text': $vuetify.breakpoint.mdAndUp}"
      @click="onSignOut()"
      outlined
      rounded
      >Đăng xuất</v-btn
    >
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'user', 'isConfirmedOTP'])
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('layout', ['setAllDialogClose']),
    async onSignOut() {
      this.setAllDialogClose()
      await this.logout()
      this.$router.push('/')
      window.location.reload()
    },
    onViewProfile() {
      this.$router.push('/profile')
    }
  }
}
</script>

<style scoped>
.btn-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
</style>
